import PropTypes from 'prop-types';
import { memo, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'reactstrap';

import Button from 'components/App/Button';
import Loading from 'components/App/Loading';

import { LOCATIONS } from 'constants/index';
import INITIAL_VALUE from 'constants/initialValue';

import cn from 'utils/classnames';

import { Avatar } from 'antd';
import IconStarDiscovery from '../IconStarDiscovery';
import styles from './DataTableReviews.module.scss';

function DataTableReviews(props) {
  const {
    isLoadingLocationList,
    locations,
    onDeleteLocation,
    onOpenDetail,
  } = props;

  const ButtonType = useCallback((deletedAt, locationId) => {
    const handleClickDetail = () => {
      if (onOpenDetail) {
        onOpenDetail(locationId);
      }
    };

    return (
      <div className="d-flex gap-3 mt-3">
        <Button
          outline
          classes="Action__Button Action__Button__Danger"
          onClick={onDeleteLocation}
          value={locationId}
        >
          {deletedAt ? 'Khôi phục' : 'Xóa'}
        </Button>

        <Button
          outline
          classes="Action__Button Action__Button__Link"
          onClick={handleClickDetail}
        >
          Xem chi tiết
        </Button>
      </div>
    );
  }, [onDeleteLocation, onOpenDetail]);

  const columns = [
    {
      header: 'User',
      render: (item) => (
        <div className="d-flex gap-2">
          <Avatar
            src={item.user.avatar}
            alt="user-avatar"
            size={32}
            round
          >
            {item.user.fullName.charAt(0).toUpperCase()}
            {item.user.fullName.charAt(1).toUpperCase()}
          </Avatar>

          <div>
            <Link
              to={`${LOCATIONS.LOCATION_DETAIL.DEFAULT}?place=${item._id}`}
              className="mb-5"
            >
              {item.user.fullName}
            </Link>

            <div className="Action">
              {ButtonType(item.deletedAt, item._id)}
            </div>
          </div>
        </div>
      ),
    },
    {
      header: 'Điểm khám phá',
      render: (item) => (
        item.discoverPlace ? (
          <div className="">
            <p className={styles.Table_Title}>
              {item.discoverPlace.name}
            </p>
            {/* <p className={styles.Table_Address}>
              134 Nguyễn Đình Chiểu, Ham Tien, Phan Thiết, Việt Nam
            </p> */}
          </div>
        ) : '-'),
    },
    {
      header: 'Hạng mục',
      render: (item) => (
        item.discoverPlace?.discoverCategories
          && item.discoverPlace.discoverCategories.length > 0
          ? (
            <div className="d-flex gap-2">
              {item.discoverPlace.discoverCategories.map((i) => (
                <p key={i._id}>{i.name}</p>
              ))}
            </div>
          )
          : '-'),
    },
    {
      header: 'Điểm đến',
      render: (item) => (
        item.discoverPlace && item.discoverPlace.discoverProvince
          ? (
            <div className="">
              {item.discoverPlace.discoverProvince.name}
            </div>
          ) : '-'),
    },
    {
      header: 'Trạng thái',
      render: (item) => (
        <div className="">
          <span className={item.deletedAt ? 'text-danger' : 'text-success'}>
            {item.deletedAt ? 'Đã xoá' : 'Đang hiển thị'}
          </span>
        </div>
      ),
    },
    {
      header: 'Điểm đánh giá',
      render: (item) => (
        <div className="">
          <IconStarDiscovery star={item.star} />
        </div>
      ),
    },
  ];

  return (
    <div className={styles.Component}>
      <Loading
        loading={isLoadingLocationList}
        loaderOnPage
      />

      <Table
        responsive
        className="Table custom_table"
      >
        <thead className="Table__Header">
          <tr className="Table__Header__Row">
            {columns.map((item) => (
              <th
                key={item.header}
                className={cn(
                  'Table__Header__Row__Content',
                  item.headerClassName,
                )}
              >
                {item.header}
              </th>
            ))
            }
          </tr>
        </thead>

        <tbody className="Table__Body">
          {locations.map((location) => (
            <tr className="Table__Body__Row" key={location._id}>
              {columns.map((item) => (
                <td
                  key={item.header}
                  className={cn(
                    'Table__Body__Row__Content',
                    item.bodyClassName,
                  )}
                >
                  {item.render(location)}
                </td>
              ))
              }
            </tr>
          ))}

          {locations.length === 0 && (
            <tr className="Table__Body__Row">
              <td
                colSpan={columns.length}
                className="Table__Body__Row__Content text-center"
              >
                Không có dữ liệu
              </td>
            </tr>
          )}
        </tbody>

      </Table>
    </div>
  );
}

DataTableReviews.propTypes = {
  isLoadingLocationList: PropTypes.bool.isRequired,
  locations: PropTypes.instanceOf(Array),
  onDeleteLocation: PropTypes.func,
  onOpenDetail: PropTypes.func,
};

DataTableReviews.defaultProps = {
  locations: [],
  onDeleteLocation: INITIAL_VALUE.FUNCTION,
  onOpenDetail: INITIAL_VALUE.FUNCTION,
};

export default memo(DataTableReviews);
